
export const EDIT_ORG_TYPE = 'EDIT_ORGANIZATION';
export const EDIT_ORG_SOCIAL  = 'EDIT_ORG_SOCIALS';
